// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SwapAction-module__container___dOnwJ{display:grid;grid-template-columns:repeat(3, 1fr);grid-row-gap:15px;row-gap:15px;overflow:hidden}", "",{"version":3,"sources":["webpack://./src/pages/teleport/mainScreen/components/SwapAction/SwapAction.module.scss"],"names":[],"mappings":"AAAA,sCACE,YAAA,CACA,oCAAA,CACA,iBAAA,CAAA,YAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "SwapAction-module__container___dOnwJ"
};
export default ___CSS_LOADER_EXPORT___;
